import React from 'react';
import { Divider } from '@chakra-ui/react';
import SelectOptions from './SelectOptions';
import TextOptions from './TextOptions';
import CheckboxOptions from './CheckboxOptions';
import RadioOptions from './RadioOptions';
import DatePickerOptions from './DatePickerOptions';

const types = {
  Checkbox: CheckboxOptions,
  DatePicker: DatePickerOptions,
  Radio: RadioOptions,
  Select: SelectOptions,
  Text: TextOptions,
};
const FieldOptions = ({ field }) => {
  const Component = types[field.type];
  if (!Component) return null;
  return (
    <>
      <Divider my="4" />
      <Component field={field} />
    </>
  );
};

export default FieldOptions;
